import './Localizacao.css';

const Localizacao = ({ config }) => {
    const address = config?.address || "Rua Exemplo, 123 - Centro, Uberlândia - MG";
    const mapsUrl = config?.mapsUrl || "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3774.2081744155825!2d-48.27552!3d-18.9185!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTjCsDU1JzA2LjYiUyA0OMKwMTYnMzEuOSJX!5e0!3m2!1spt-BR!2sbr!4v1620000000000!5m2!1spt-BR!2sbr";
    const openingHours = config?.openingHours || [
        "Seg a Sex: 09h — 20h",
        "Sábados: 08h — 18h"
    ];

    // Detect if mapsUrl is an iframe src, a search query, or a direct link
    let iframeSrc = mapsUrl.includes('<iframe') ?
        mapsUrl.match(/src="([^"]+)"/)?.[1] || mapsUrl :
        mapsUrl;

    // Auto-fix: If it's a search/query link, convert it to a fallback embed URL
    if (iframeSrc.includes('google.com/maps/search') || iframeSrc.includes('google.com/maps?q=')) {
        try {
            const urlObj = new URL(iframeSrc);
            const query = urlObj.searchParams.get('query') || urlObj.searchParams.get('q');
            if (query) {
                iframeSrc = `https://maps.google.com/maps?q=${encodeURIComponent(query)}&output=embed`;
            }
        } catch (e) {
            console.warn("Invalid URL format for maps auto-fix");
        }
    }

    // Final Fallback: If still not an embed URL, use the address to generate one
    let finalIframeSrc = iframeSrc;
    const isEmbeddable = finalIframeSrc.includes('google.com/maps/embed') || finalIframeSrc.includes('output=embed');

    if (!isEmbeddable && address) {
        finalIframeSrc = `https://maps.google.com/maps?q=${encodeURIComponent(address)}&output=embed`;
    }

    const isValidEmbed = true; // Since we forced a fallback above

    const directMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;

    return (
        <section className="location-section" id="localizacao">
            <div className="location-glow"></div>
            <div className="location-container">
                <div className="location-header fade-in">
                    <h2 className="location-title">ONDE ESTAMOS</h2>
                    <p className="location-subtitle">Venha viver a experiência premium em nosso espaço</p>
                </div>

                <div className="location-content">
                    <div className="location-map-wrapper fade-in">
                        <div className="map-frame">
                            {isValidEmbed ? (
                                <iframe
                                    title="Barbearia Map"
                                    src={finalIframeSrc}
                                    width="100%"
                                    height="100%"
                                    style={{ border: 0 }}
                                    allowFullScreen=""
                                    loading="lazy"
                                ></iframe>
                            ) : (
                                <div className="map-fallback-ui">
                                    <div className="fallback-inner">
                                        <div className="fallback-icon">📍</div>
                                        <h3>Mapa Indisponível</h3>
                                        <p>O link configurado não permite visualização interna direta.</p>
                                        <div className="fallback-actions">
                                            <a href={iframeSrc} target="_blank" rel="noopener noreferrer" className="fallback-btn secondary">
                                                ABRIR LINK ORIGINAL
                                            </a>
                                            <div className="fallback-tip">
                                                <strong>Dica:</strong> Para mostrar o mapa aqui, use a opção "Incorporar mapa" no Google Maps.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className="floating-address-card fade-in">
                            <div className="address-item">
                                <div className="icon-box">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" /><circle cx="12" cy="10" r="3" /></svg>
                                </div>
                                <div className="text-content">
                                    <h3>Nosso Endereço</h3>
                                    <p>{address}</p>
                                </div>
                            </div>

                            <div className="address-item">
                                <div className="icon-box">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></svg>
                                </div>
                                <div className="text-content">
                                    <h3>Horários</h3>
                                    {Array.isArray(openingHours) ? openingHours.map((h, i) => (
                                        <p key={i}>{h}</p>
                                    )) : <p>{openingHours}</p>}
                                </div>
                            </div>

                            <a
                                href={directMapsUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="directions-btn-modern"
                            >
                                <span>VER NO MAPA</span>
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="7" y1="17" x2="17" y2="7" /><polyline points="7 7 17 7 17 17" /></svg>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Localizacao;
